export const FETCH_ALL_FORMVIEWS = 'formViews/FETCH_ALL_FORMVIEWS'


